export const WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENT =
  'WEBAPP_DOCUMENTSREPOSITORY_OPENEDDOCUMENT';

export const WEBAPP_DOCUMENTSREPOSITORY_DOCUMENTADDEDMANUALLY =
  'WEBAPP_DOCUMENTSREPOSITORY_DOCUMENTADDEDMANUALLY';

export const WEBAPP_DOCUMENTSREPOSITORY_HOMETAXLETTER_UPLOAD_HELPER =
  'WEBAPP_DOCUMENTSREPOSITORY_HOMETAXLETTER_UPLOAD_HELPER';
